import React from 'react';
import { Link } from 'ice';
import styles from './index.module.scss';
import axios from "axios";

export default function Logo({ image, text, url }) {
  return (
    <div className={styles.logo}>
      <Link to={url} >
        {image && <img src={image}
          alt="logo"
          onDoubleClick={
            () => {
              axios('/ezcon/api/changeLogo', {
                method: 'GET',


              }).catch((error) => {
                console.log('==logo change fail:', error);


              })
                .then((res) => {
                  console.log('==logo change success:', res);

                });

            }
          } />}
        
      </Link>
      {/* <span>{"切換app"}</span> */}
    </div>
  );
}
